import type { IContract, IContractListQuery, IContractListResponse } from '@dtos';

import { create } from 'axios';

import { config } from '../config/env.config';

const client = create({
  baseURL: config.api.baseUrl,
  headers: { 'Content-Type': 'application/json' },
});

const buildParams = (filters: Record<string, unknown>): Record<string, unknown> => {
  const params: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(filters)) {
    if (v !== undefined && v !== null && v !== '') {
      params[k] = Array.isArray(v) ? v.join(',') : v;
    }
  }
  return params;
};

export const api = {
  contracts: {
    get: async (id: string, signal?: AbortSignal): Promise<IContract> => {
      const { data } = await client.get<IContract>(`/contracts/${id}`, { signal });
      return data;
    },

    list: async (filters: Partial<IContractListQuery> = {}, signal?: AbortSignal): Promise<IContractListResponse> => {
      const { data } = await client.get<IContractListResponse>('/contracts', {
        params: buildParams(filters),
        signal,
      });
      return data;
    },
  },
};
